package com.devi3east.bashbuddy.auth.ui.components.steps

import androidx.compose.foundation.layout.padding
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.devi3east.bashbuddy.account.organization.domain.models.Organization
import com.devi3east.bashbuddy.auth.ui.AuthUiState
import com.devi3east.bashbuddy.auth.ui.components.OrganizationPicker

@Composable
fun SignUpSupportStep(
    uiState: AuthUiState,
    organizations: List<Organization>,
    selectedOrganization: Organization?,
    onOrganizationSelected: (Organization?) -> Unit
) {
    Text(
        text = "Show Your Support!",
        style = MaterialTheme.typography.headlineMedium.copy(
            fontWeight = FontWeight.Bold,
            color = MaterialTheme.colorScheme.onSurface
        ),
        textAlign = TextAlign.Center
    )

    Text(
        text = "Select an organization and help them compete for a $500 donation!",
        style = MaterialTheme.typography.bodyMedium.copy(
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            lineHeight = 20.sp
        ),
        textAlign = TextAlign.Center,
        modifier = Modifier.padding(horizontal = 8.dp)
    )

    HorizontalDivider(
        thickness = 1.dp,
        color = MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.3f)
    )

    OrganizationPicker(
        organizations = organizations,
        selectedOrganization = selectedOrganization,
        onSelected = onOrganizationSelected
    )

    if (!uiState.errorMessage.isNullOrBlank()) {
        Text(
            text = uiState.errorMessage,
            color = MaterialTheme.colorScheme.error,
            style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Medium),
            textAlign = TextAlign.Center
        )
    }

}